module.exports = __webpack_public_path__ + "static/media/majors-student-university-of-arizona.d3be999f.png";